import React from 'react'
import { getIcons } from '../../Constant/Constant'

const CreateNewSpinWheelButton = ({onclick}) => {
    const icon = getIcons()
  return (
    <div onClick={ onclick}>
      <div className='border-2 border-gray-400 border-dashed w-full h-40 rounded-md pt-8 cursor-pointer'

        >

        <div className='flex gap-3 items-center justify-center' onC
        >
            <img src={icon.spinwheelcreateIcon} alt="" />
            <h1 className='text-lg font-medium'>Create New Spin Wheel</h1>
        </div>

      </div>
    </div>
  )
}

export default CreateNewSpinWheelButton
